export const privateAreas = [
    '.pink-area',
    '.blue-area',
    '.orange-area',
];

export const privateMapData = {
    'pink-area': {
        title: 'Dariusz Małczak',
        phone: '+48 501 363 129',
        email: '',
    },
    'blue-area': {
        title: 'Rafał Młynarczyk',
        phone: '+48 501 266 363',
        email: '',
    },
    'orange-area': {
        title: 'Marek Czubara',
        phone: '+48 501 527 980',
        email: '',
    }
};
